import { render } from "./DADataTableLazy.vue?vue&type=template&id=94534598&scoped=true"
import script from "./DADataTableLazy.vue?vue&type=script&lang=js"
export * from "./DADataTableLazy.vue?vue&type=script&lang=js"

import "./DADataTableLazy.vue?vue&type=style&index=0&id=94534598&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94534598"]])

export default __exports__